export enum SofStatus {
  REQUESTED = 'REQUESTED', // SOF has been requested but the user has not entered the flow yet
  INIT = 'INIT', // The user has entered the flow
  PENDING = 'PENDING', // The user has submitted their docs, SumSub is processing them
  ON_HOLD = 'ON_HOLD', // SumSub could not process the docs automatically, awaiting admin action
  SUCCESS = 'SUCCESS', // SOF successfully passed
  DECLINED = 'DECLINED', // SOF not passed, user is not valid
  FAILED = 'FAILED', // An unexpected error has happened while handling some action
}
